import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Stagger, Item } from "@/components/Reveal";
import { INDUSTRIES, IMAGES } from "@/data/site";

const spans = [
  "md:col-span-6 lg:col-span-5",
  "md:col-span-3 lg:col-span-4",
  "md:col-span-3 lg:col-span-3",
  "md:col-span-3 lg:col-span-3",
  "md:col-span-6 lg:col-span-6",
  "md:col-span-3 lg:col-span-3",
  "md:col-span-3 lg:col-span-4",
  "md:col-span-3 lg:col-span-3",
  "md:col-span-6 lg:col-span-5",
];

export default function Industries() {
  return (
    <div data-testid="page-industries" className="pt-32">
      <section className="relative">
        <div className="max-w-7xl mx-auto px-6 md:px-10 pt-10 pb-16 md:pt-20 md:pb-24">
          <Reveal>
            <div className="overline mb-5">Industries We Serve</div>
          </Reveal>
          <Reveal delay={0.05}>
            <h1 className="font-display text-4xl md:text-7xl text-white leading-[1.05] tracking-tight max-w-5xl">
              Deep <span className="italic gold-gradient-text">Sector Intelligence</span> Across Borders
            </h1>
          </Reveal>
          <Reveal delay={0.12}>
            <p className="mt-7 max-w-3xl text-white/70 text-lg leading-relaxed">
              From real estate and tourism to logistics and family businesses — we bring industry-specific insight to
              every engagement, grounded in the realities of UAE, India and global markets.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="relative pb-24 md:pb-32">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <Stagger className="grid grid-cols-1 md:grid-cols-6 lg:grid-cols-12 gap-5">
            {INDUSTRIES.map((it, i) => (
              <Item key={it} className={spans[i % spans.length]}>
                <div className="lux-card gold-brackets relative min-h-[180px] md:min-h-[220px] p-6 md:p-8 flex flex-col justify-between overflow-hidden">
                  <div
                    className="absolute inset-0 opacity-10"
                    style={{
                      backgroundImage: `url(${i % 2 === 0 ? IMAGES.meeting : IMAGES.boardroom})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      filter: "grayscale(60%)",
                    }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-br from-[#0A0A0A]/85 via-[#0A0A0A]/65 to-[#0B3D2E]/40" />
                  <div className="relative flex items-start justify-between">
                    <span className="text-[10px] uppercase tracking-[0.28em] text-[#D4AF37]">
                      Sector · {String(i+1).padStart(2,"0")}
                    </span>
                  </div>
                  <h3 className="relative font-display text-2xl md:text-[28px] text-white leading-tight tracking-tight">
                    {it}
                  </h3>
                </div>
              </Item>
            ))}
          </Stagger>
        </div>
      </section>

      <section className="relative py-20 md:py-28 bg-[#0c0c0c] border-t border-white/5">
        <div className="max-w-5xl mx-auto px-6 md:px-10 text-center">
          <Reveal>
            <h2 className="font-display text-3xl md:text-5xl text-white leading-tight">
              Don&apos;t see your sector? <span className="italic gold-gradient-text">Let&apos;s talk.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-5 text-white/70 max-w-2xl mx-auto">
              Our research-driven methodology adapts to nuanced industries and emerging categories.
            </p>
          </Reveal>
          <Reveal delay={0.18}>
            <div className="mt-9">
              <Link to="/contact" className="btn-gold" data-testid="industries-cta">
                Start The Conversation <ArrowRight size={18} />
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
